import React, { useEffect, useRef, useState } from "react";

declare global {
  interface Window {
    naver: any;
  }
}

interface MapProps {
  location: {
    name: string;
    latitude: number;
    longitude: number;
  };
}

const Map: React.FC<MapProps> = ({ location }) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const [mapError, setMapError] = useState(false);

  useEffect(() => {
    if (!mapRef.current) return;

    const { naver } = window as any;
    if (!naver) {
      setMapError(true);
      return;
    }

    try {
      const mapOptions = {
        center: new naver.maps.LatLng(location.latitude, location.longitude),
        zoom: 17,
        zoomControl: true,
        zoomControlOptions: {
          position: naver.maps.Position.TOP_RIGHT,
        },
      };

      const map = new naver.maps.Map(mapRef.current, mapOptions);
      const marker = new naver.maps.Marker({
        position: new naver.maps.LatLng(location.latitude, location.longitude),
        map: map,
      });
    } catch (error) {
      console.error("지도 로드 중 오류 발생:", error);
      setMapError(true);
    }
  }, [location]);

  if (mapError) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <h3 style={{ marginBottom: "10px" }}>{location.name}</h3>
        <p style={{ marginBottom: "5px" }}>위도: {location.latitude}</p>
        <p>경도: {location.longitude}</p>
      </div>
    );
  }

  return <div ref={mapRef} style={{ width: "100%", height: "100%" }} />;
};

export default Map;
